import { Injectable } from '@angular/core';
import {
	Router,
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';

import { Config } from '@core/models/config';
import { ConfigService } from '@core/services/config.service';

@Injectable()
export class ConfigResolver implements Resolve<Config> {

	constructor(private configService: ConfigService,
		private router: Router) {

	}

	async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Config> {

		const config = await this.configService.initializeConfig();
		return config;
	}
}